import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

function SvgGooglePayColour(props) {
  return /*#__PURE__*/jsxs("svg", {
    width: "43",
    height: "32",
    viewBox: "-3 1 43 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.4108 17.8903V22.2247H18.9658V11.5228H22.7995C23.7736 11.5228 24.5993 11.8321 25.2805 12.4496C25.9731 13.0671 26.3184 13.8196 26.3184 14.7061C26.3184 15.6132 25.9731 16.3706 25.2805 16.9779C24.6105 17.586 23.7829 17.8895 22.7995 17.8895H20.4108V17.8903ZM20.4108 12.8383V16.5747H22.8305C23.4066 16.5747 23.8833 16.3903 24.2606 16.0215C24.6481 15.6534 24.8414 15.2142 24.8414 14.7061C24.8414 14.2083 24.6481 13.7744 24.2606 13.4054C23.8833 13.0269 23.4066 12.8374 22.8305 12.8374H20.4108V12.8383Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.6483 14.6619C30.7172 14.6619 31.5598 14.933 32.1782 15.4764C32.7966 16.0198 33.1044 16.7642 33.1044 17.7106V22.2246H31.7222V21.2086H31.6593C31.0625 22.0451 30.2667 22.4633 29.272 22.4633C28.4238 22.4633 27.7125 22.2246 27.1429 21.7465C26.5715 21.2676 26.2861 20.6705 26.2861 19.952C26.2861 19.1951 26.5864 18.5927 27.1889 18.1445C27.7913 17.6963 28.5955 17.4716 29.6005 17.4716C30.4591 17.4716 31.1666 17.6212 31.7212 17.9197V17.6056C31.7212 17.1275 31.5222 16.7218 31.1244 16.388C30.7256 16.0538 30.2611 15.8875 29.7263 15.8875C28.9192 15.8875 28.2812 16.211 27.8101 16.8594L26.5367 16.0966C27.2396 15.14 28.2756 14.6619 29.6483 14.6619ZM27.7782 19.9823C27.7782 20.3417 27.9377 20.6401 28.2577 20.8797C28.5777 21.1182 28.9511 21.2381 29.3809 21.2381C29.9891 21.2381 30.5295 21.0236 31.0062 20.5955C31.4829 20.1665 31.7212 19.6642 31.7212 19.0869C31.2708 18.7473 30.6421 18.5784 29.836 18.5784C29.2495 18.5784 28.7597 18.7133 28.3675 18.9823C27.9753 19.2514 27.7782 19.5838 27.7782 19.9823Z",
      fill: "white"
    }), /*#__PURE__*/jsx("mask", {
      id: "mask0_488:4149",
      maskUnits: "userSpaceOnUse",
      x: "33",
      y: "14",
      width: "9",
      height: "12",
      children: /*#__PURE__*/jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33.3398 14.9009H41.0382V25.4526H33.3398V14.9009Z",
        fill: "white"
      })
    }), /*#__PURE__*/jsx("g", {
      mask: "url(#mask0_488:4149)",
      children: /*#__PURE__*/jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M41.0383 14.9009L36.2141 25.4526H34.7222L36.5135 21.7608L33.3398 14.9009H34.9117L37.2051 20.1621H37.236L39.4666 14.9009H41.0383Z",
        fill: "white"
      })
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5701 16.9559C14.5701 16.5229 14.5316 16.1051 14.4588 15.7052H8.36328V18.0735H11.8545C11.7047 18.8456 11.2516 19.5024 10.5638 19.9422V21.4802H12.6474C13.8673 20.4095 14.5701 18.8269 14.5701 16.9559Z",
      fill: "#4285F4"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.36363 22.9655C10.1081 22.9655 11.5766 22.4204 12.6477 21.4803L10.5641 19.9423C9.98422 20.314 9.23723 20.5312 8.36363 20.5312C6.67781 20.5312 5.24684 19.4498 4.73494 17.9927H2.58838V19.5767C3.65205 21.5858 5.83846 22.9655 8.36363 22.9655Z",
      fill: "#34A853"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.73471 17.9925C4.60382 17.6212 4.53201 17.2248 4.53201 16.8155C4.53201 16.4067 4.60382 16.0103 4.73471 15.6385V14.0544H2.58815C2.1485 14.8848 1.8999 15.8223 1.8999 16.8155C1.8999 17.8089 2.1485 18.7473 2.58815 19.5765L4.73471 17.9925Z",
      fill: "#FABB05"
    }), /*#__PURE__*/jsx("mask", {
      id: "mask1_488:4149",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "10",
      width: "11",
      height: "6",
      children: /*#__PURE__*/jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.58838 10.6666H12.6881V15.6386H2.58838V10.6666Z",
        fill: "white"
      })
    }), /*#__PURE__*/jsx("g", {
      mask: "url(#mask1_488:4149)",
      children: /*#__PURE__*/jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.36363 13.1006C9.31606 13.1006 10.17 13.412 10.8433 14.0229V14.0238L12.6881 12.2685C11.5677 11.2761 10.1071 10.6666 8.36363 10.6666C5.83846 10.6666 3.65205 12.0456 2.58838 14.0545L4.73494 15.6387C5.24684 14.1815 6.67781 13.1006 8.36363 13.1006Z",
        fill: "#E94235"
      })
    })]
  });
}

export { SvgGooglePayColour as default };
